module.exports = __webpack_public_path__ + "img/concredito.067c6fdc.png";